<template>
    <document-head title="Home"/>

    <app-layout>
        <div class="mt-8 flex flex-row justify-between">
            <h1 class="text-3xl font-semibold text-gray-900">Home</h1>
            <div>
                <Link class="mr-2 py-2 px-4 rounded text-white" style="background: #06F195;" :href="route('tig::levels.index')">
                    The Impossible Game 2 Levels
                </Link>
                <Link class="py-2 px-4 rounded text-white bg-blue-400" :href="route('snail::levels.index')">
                    Will You Snail? Levels
                </Link>
            </div>
        </div>
        <div class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
            <div class="p-6">
                <div class="flex items-center">
                    <div class="ml-4 text-lg leading-7 font-semibold">
                        <a href="https://laravel.com/docs" class="underline text-gray-900 dark:text-white">About</a>
                    </div>
                </div>
                <div class="ml-12">
                    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        UserLevels.com is a service that aims to provide a clean, easy, and feature-rich experience
                        for sharing user-generated content for various types of games. All service is provided for
                        free for the communities so if you find this service helpful and want to support the
                        developers, we would very much appreciate if you could throw even a dollar at our
                        <a href="https://patreon.com/SeeBeyond" class="underline font-bold" style="color: #FF424D;">
                            Patreon</a> page. If you have any questions or need any help, you can get in contact
                        via Discord with <span class="rounded bg-gray-100 px-1 font-mono font-bold">noelloelle#2898</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
            <div class="p-6">
                <div class="flex items-center">
                    <div class="ml-4 text-lg leading-7 font-semibold">
                        <a href="https://laravel.com/docs" class="underline text-gray-900 dark:text-white">Games</a>
                    </div>
                </div>
                <div class="ml-12">
                    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        <p>UserLevels.com is not affiliated with the developers or the games themselves</p>
                        <span class="font-bold">Supported: </span>
                        <ul>
                            <li>The Impossible Game 2</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-4 bg-white dark:bg-gray-800 overflow-hidden shadow sm:rounded-lg">
            <div class="p-6">
                <div class="flex items-center">
                    <div class="ml-4 text-lg leading-7 font-semibold">
                        <a href="https://laravel.com/docs" class="underline text-gray-900 dark:text-white">Changelog</a>
                    </div>
                </div>
                <div class="ml-12">
		    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        <span class="font-bold">July 27, 2026: </span>Guh
                        <ul>
                            <li>- Added pagination to load TIG level index easier</li>
                        </ul>
                    </div>

                    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        <span class="font-bold">June 25, 2022: </span>Small bugfixes, thanks to DeepIntermission#1586 for catching them!
                        <ul>
                            <li>- Fixed submit bug when editing a WYS level file</li>
                            <li>- Fixed links to WYS user profiles</li>
                            <li>- Added WYS to supported game list</li>
                        </ul>
                    </div>
                    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        <span class="font-bold">June 25, 2022: </span>I added Snail support.
                        <ul>
                            <li>- Added Snail support.</li>
                        </ul>
                    </div>
                    <div class="mt-2 text-gray-600 dark:text-gray-400 text-sm">
                        <span class="font-bold">March 27, 2022: </span>Nice to see people in the TIG 2 community
                        making use of my site! Since Fluke Games hasn't confirmed when we will be getting an official
                        level portal and this one is linked in the Discord, I figure I'll make it look nice for now.
                        <ul>
                            <li>- Fixed edit level button placement</li>
                            <li>- Added more info to front page</li>
                            <li>- Levels sorted by newest</li>
                            <li>- Added version indicator</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="text-center text-sm text-gray-500 sm:text-left">
                <div class="flex items-center">
                    Crafted with
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" class="mx-1 -mt-px w-4 h-4 text-red-500">
                        <path
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                    </svg>
                    By
                    <a href="https://bird.cafe" class="ml-1 underline">Bird Cafe</a>
                </div>
            </div>
            <div class="ml-4 text-center text-sm text-gray-500 sm:text-right sm:ml-0">
                Running <span class="font-mono bg-white rounded px-1">levelator-beta</span> build <a class="font-mono bg-white rounded px-1" href="#">{{ $page.props.app.build }}</a>
            </div>
        </template>
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/App'
import {Head as DocumentHead, Link} from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayout,
        DocumentHead,
        Link,
    }
}
</script>
